import React, { Component } from 'react';
import { Route, Redirect } from 'react-router';
import { Link } from 'react-router-dom';

// page
import Page from '../../pages/Page/Banner';
// components
import Signup from '../../pages/Auth/SignupPage';
import Login from '../../pages/Auth/LoginPage';
import Recovery from '../../pages/Auth/RecoveryPage';
// css
import './Auth.css';

class Auth extends Component {
  render() {
    const match = this.props.match || { url: "" };
    const url = match.url;
    return (
      <Page>
        <Route exact path={`${url}/`} component={() => <Redirect to={`${url}/login`} />} />
        <Route path={`${url}/login`} component={Login} />
        <Route path={`${url}/signup`} component={Signup} />
        <Route path={`${url}/recovery`} component={Recovery} />
        <div className="Auth-switch-link">
          <Link to="/">Home</Link>
        </div>
      </Page>
    );
  }
}

export default Auth;


// WEBPACK FOOTER //
// ./src/entries/Auth/Auth.js